/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Table as AntdTable, Spin, Icon } from 'antd';
import styled from 'styled-components';

const itemRender = (current, type, originalElement, page) => {
    const styles = {
        border: '2px solid black !important',
        borderRadius: '3px',
        color: '#000',
    }
    if (type === 'prev') {
        return <a style={{ paddingRight: '5px', color: '#2D4D7E', fontFamily: 'Montserrat' }}>anterior</a>;
    }
    if (type === 'next') {
        return <a style={{ paddingLeft: '5px', color: '#2D4D7E', fontFamily: 'Montserrat' }}>siguiente</a>;
    }
    if (type === 'page') {
        return <a style={styles}>{current}</a>;
    }
    return originalElement;
}

const Table = ({ columns, data, scroll, loading, size, pagination, pageSize, totalPages, onchange, rowSelection }) => {
    const antIcon = <Icon type="loading" style={{ fontSize: 24, color: '#2D4D7E' }} spin />
    const text = <span style={{ fontSize: 14, color: '#2D4D7E' }} >Cargando...</span>
    // console.log("Datasource:",data)
    return (
        <Style>
            <Spin tip={text} indicator={antIcon} spinning={loading || false}>
                <AntdTable
                    scroll={scroll}
                    columns={columns}
                    dataSource={data}
                    pagination={{ itemRender, defaultPageSize: 6 }}
                    size={size}
                    rowSelection={{
                        onChange: (data,record) => rowSelection(data,record),
                    }}
                    pagination={pageSize ? {
                        pageSize: pageSize,
                        total: totalPages,
                        onChange: (page) => onchange(page),
                        showQuickJumper: true,
                    } : pagination
                    }
                    rowKey={record => (
                        record.id
                        || record.key
                    )}  // si se accede de diferente manera al id agregarlo acá
                />
            </Spin>
        </Style>
    )
}

const Style = styled.div`
font-family: Montserrat;
padding: 10px 20px;
.ant {
    &icon {
        /* Tamaño del icono */
        font-size: 20px !important;
    }
    &-table {
        &-wrapper {
            /* Borde y redondeo de toda la tabla */
            border: 1px solid #DFE0EB !important;
        }
        &-row {
            /* Color del borde por cada fila */
            border-bottom: 1px solid #DFE0EB !important;
            border-top: 1px solid #DFE0EB !important;
            /* Espacio entre cada campo  */
            font-size: 12px;
            padding: 4px 4px !important;
        }
        &-small {
            border: 0px !important;
            & > .ant-table-content > .ant-table-body {
                /* Tamaño de los laterales de la tabla */
                margin: 0px !important;
            }
        }
        &-tbody {
            color: #2D4D7E !important;
            font-weight: 500 !important;
        }
        &-thead {
            & > tr > th {
                /* Transparentar las columnas con el nombre */
                background: #FBFBFB !important;
                border-bottom: 1px solid rgba(0,0,0,0) !important;
                color: #2D4D7E !important;
                border-bottom: 1px solid #DFE0EB !important;
                font-weight: 700!important;
                white-space: pre-line;
                & .ant-table-column-sorter .ant-table-column-sorter-inner {
                    /* Margen del icono */
                    margin-top: -0.35em !important;
                }
            }
        }
        table {
            /* usado para manipular margenes */
            border-collapse: collapse;
        }
        &-pagination.ant-pagination {
            /* Centrar la paginación */
            float: none;
            text-align: center !important;
        }
    }
    &-pagination {
        margin: 40px 0px;
        &-item {
            &-active {
                /* Color del border de la paginación seleccionada */
                border-color: #DFE0EB !important;
                & a {
                    /* Color del fondo y fuente de la paginación seleccionada */
                    color: #fff !important;
                    background: #ED7201 !important;
                    font-weight: 900 !important;
                }
            }
        }
        &.mini .ant-pagination-item {
            /* Espacio entre cada item de la paginacion */
            margin: 0px 3px !important;
            &:not(.ant-pagination-item-active) {
                /* Color del border de la paginación no seleccionado */
                border-color: black !important;
            }
        }
        &-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis, .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis .ant-pagination-item-link-icon {
            /* Color para desplazamiento de 5 en 5 items */
            color: #000 !important;
        }
    }
}
`

export default Table;



// WEBPACK FOOTER //
// ./src/Components/Utils/Table.js